import React, { useEffect, useRef, useState } from "react";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";
import { useFormik } from "formik";
import * as Yup from "yup";
import ICustomAddSkills from "./ICustomAddSkills";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useSelector } from "react-redux";
import IAddPortfolioImages from "./IAddPortfolioImages";
import DisplayFileProper from "../../../../Common/FilesRelevent/DisplayFileProper";
import {
  scrollToTop,
  urlValidation,
} from "../../../../../CloudStorage/CommonFunction";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import axiosInstance from "../../../../../redux/api";
import { descriptionvalidation, titlevalidation } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const IAddPortfolio = ({ formData, setFormData, nextPage, previousPage }) => {
  const [loading, setLoading] = useState(false);
  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);
  const [allSkills, setAllSkills] = useState("");
  const [popularSkills, setPopularSkills] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [updateIndex, setUpdateIndex] = useState(null);

  // Validation schema using Yup
  const validationSchema = Yup.object({
    title: titlevalidation,
    url: Yup.string()
      .test("valid-url", "Enter a valid URL", (value) => urlValidation(value))
      .required("URL is required"),
    description: descriptionvalidation,
    skills: Yup.array()
      .required("This Field is Required")
      .min(3, "Please select at least 3 competencies"),
    files: Yup.array()
      .required("This Field is Required")
      .min(1, "Please upload at least one file"),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      title: "",
      url: "",
      description: "",
      skills: [],
      files: [],
    },
    validationSchema,
    onSubmit: (values) => {
      const updatedWorkSample = {
        ...values,
        files: Array.isArray(values.files) ? values.files : [],
      };

      if (updateIndex !== null) {
        setFormData((prevData) => ({
          ...prevData,
          work_sample: prevData.work_sample.map((sample, index) =>
            index === updateIndex ? updatedWorkSample : sample,
          ),
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          work_sample: [...prevData.work_sample, updatedWorkSample],
        }));
      }
      closeModal();
    },
  });

  const openModal = () => {
    setModalOpen(true);
    scrollToTop();
  };

  const closeModal = () => {
    setModalOpen(false);
    formik.resetForm(); // Reset form after close
    setUpdateIndex(null);
  };

  // useEffect(() => {
  //   setAllSkills(skillsss);
  //   setPopularSkills(skillsss);
  // }, [skillsss]);
  const getCategoryIds = (categories) => {
    if (!Array.isArray(categories)) return "";
    const ids = categories.flatMap((cat) => [
      cat.id,
      ...(Array.isArray(cat.sub_categories)
        ? cat.sub_categories.map((sub) => sub.id)
        : []),
    ]);
    return ids.join(",");
  };


  useEffect(() => {
    if (formData?.categories?.length) {
      const categoryIds = getCategoryIds(formData?.categories);
      axiosInstance
        .get(`category?type=6&category_id=${categoryIds}`)
        .then((res) => {
          if (res?.data) {
            // console.log(res?.data, 'res?.data');

            setAllSkills(res.data?.response);
            setPopularSkills(res.data?.response);
          }
        })
        .catch((err) => {
          console.error("Error fetching skills:", err);
        });
    }
  }, [formData?.categories]);

  const updatePortfolio = (index) => {
    formik.setValues(formData.work_sample[index]); // Set Formik values to edit
    setUpdateIndex(index);
    openModal();
  };

  const deletePortfolio = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      work_sample: prevData.work_sample.filter((_, i) => i !== index),
    }));
  };

  const SubmitAndNext = async () => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    nextPage();
    // if (formData.work_sample.length > 0) {
    //   nextPage();
    // } else {
    //   formik.setFieldError("work_sample", "At least add one portfolio item");
    // }
    setLoading(false);
  };

  const modalRef = useRef(null);
  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalOpen]);

  useEffect(() => {
    if (modalOpen && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [modalOpen]);

  return (
    <div>
      <div
        className="add-education-modal"
        style={{ right: modalOpen ? "0" : "-100%" }}
        ref={modalRef}
      >
        <div className="modal-width">
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-head">
              <h3>{updateIndex !== null ? "Edit" : "Add"} work sample</h3>
              <button
                type="button"
                onClick={closeModal}
                className="btn close-modal-btn"
              >
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                  alt=""
                />
              </button>
            </div>

            <div className="form-group">
              <label className="label">Project Title <AsteriskLabel/></label>
              <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Enter Title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.title && formik.errors.title ? (
                <p style={{ color: "red" }}>{formik.errors.title}</p>
              ) : null}
            </div>

            <IAddPortfolioImages
              selectedfiles={formik.values.files}
              setWork_sample={(files) => formik.setFieldValue("files", files)}
              formik={formik}
            />

            <ICustomAddSkills
              popularSkills={popularSkills}
              allSkills={allSkills}
              parentselectedskills={formik.values.skills}
              setWork_sample={(skills) =>
                formik.setFieldValue("skills", skills)
              }
              formik={formik}
            />

            <div className="form-group">
              <label className="label">Project URL <AsteriskLabel/></label>
              <input
                type="text"
                name="url"
                className="form-control"
                placeholder="Type URL"
                value={formik.values.url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.url && formik.errors.url ? (
                <p style={{ color: "red" }}>{formik.errors.url}</p>
              ) : null}
            </div>

            <div className="form-group">
              <>
                <CustomReactQuill
                  value={formik.values.description}
                  formik={formik}
                  name={"description"}
                  title={(<>Project Description <AsteriskLabel/></>)}
                />
              </>
              {formik.touched.description && formik.errors.description ? (
                <p style={{ color: "red" }}>{formik.errors.description}</p>
              ) : null}
            </div>

            <div className="add-btn">
              <button type="submit">
                {updateIndex !== null ? "Edit" : "Add"} work
              </button>
            </div>
          </form>
        </div>
      </div>

      <div className="row about-row">
        <div className="col-md-5 about-left">
          <h6>
            04/9 <span>Work samples</span>
          </h6>
          <h2>
            Showcase previous <span>work & samples</span>
          </h2>
          <p>Upload your portfolio to impress users with your work...</p>
        </div>

        <div className="col-lg-6   about-right">
          {/* <h6>My work samples</h6> */}
          <div className="add-skip">
            <h6>My work samples </h6>
            <a onClick={() => SubmitAndNext()} type="text">
              Skip for now
            </a>
          </div>
          <div className="row add-wrapper">
            {formData?.work_sample?.map((item, index) => (
              <div key={index} className="col-md-6">
                <div className="add-education-wrapper1">
                  <div className="edu-img">
                    <DisplayFileProper item={item?.files[0]} />
                  </div>
                  <div className="add-button-education">
                    <button onClick={() => deletePortfolio(index)}>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                        alt=""
                      />
                    </button>
                    <button onClick={() => updatePortfolio(index)}>
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                  <h2>
                    {decodeHtml(item.title).substring(0, 16)}
                    {decodeHtml(item.title).length > 16 ? "..." : ""}
                  </h2>
                </div>
              </div>
            ))}
          </div>

          {formik.errors.work_sample && (
            <p style={{ color: "red" }}>{formik.errors.work_sample}</p>
          )}

          <button className="add-education-btn work-btn" onClick={openModal}>
            Add work sample
          </button>
        </div>
      </div>

      <div className="button-container">
        <button
          disabled={loading}
          type="button"
          onClick={previousPage}
          className="prev-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/back-arrow.svg`}
            alt=""
          />
          Back
        </button>
        <button type="button" onClick={SubmitAndNext} className="next-button">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default IAddPortfolio;
